module.exports = __webpack_public_path__ + "static/media/add_blue.41d992c7.png";